import styled from 'styled-components';
import { message } from 'antd';

const AppAlert = alert => message.warning(alert.message);
export { AppAlert };



// WEBPACK FOOTER //
// ./src/sc-ui/AppAlert.jsx